import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

interface LeaveEditorConfirmProps {
  open: boolean;
  canKeepDraft: boolean;
  onDiscard: () => void;
  onKeep: () => void;
  onStay: () => void;
}

export default function LeaveEditorConfirm({ open, canKeepDraft, onDiscard, onKeep, onStay }: LeaveEditorConfirmProps) {
  return (
    <Dialog open={open}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Leave editor?</DialogTitle>
        </DialogHeader>
        <div className="space-y-3 text-sm text-muted-foreground">
          <p>You have unsaved changes. Choose how to proceed.</p>
        </div>
        <DialogFooter className="gap-2">
          <Button variant="secondary" onClick={onStay} data-testid="leave-stay">Stay</Button>
          <Button variant="destructive" onClick={onDiscard} data-testid="leave-discard">Discard and leave</Button>
          <Button onClick={onKeep} disabled={!canKeepDraft} data-testid="leave-keep">Keep draft and leave</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}


